import globals from "../../globals";
import { _sendWithAxios } from "../api";

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

// STATUS OFERTA - LISTAGEM
export const listarStatusOferta = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}StatusOferta/listar`,
    "GET"
  );
};

// STATUS OFERTA - BUSCAR POR ID
export const buscarStatusOfertaPorId = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}StatusOferta/${id}`,
    "GET"
  );
};

// STATUS OFERTA - ADICIONAR
export const adicionarStatusOferta = async (data) => {
  const payload = {
    descricao: data.descricao?.trim(),
    ativo: true,
    dataCriacao: new Date().toISOString(),
    dataAtualizacao: new Date().toISOString(),
  };
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}StatusOferta/criar`,
    "POST",
    payload
  );
};

// STATUS OFERTA - ALTERAR
export const alterarStatusOferta = async (data) => {
  const payload = {
    id: data.id,
    descricao: data.descricao?.trim(),
    ativo: data.ativo !== undefined ? data.ativo : true,
    dataCriacao: data.dataCriacao || new Date().toISOString(),
    dataAtualizacao: new Date().toISOString(),
  };
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}StatusOferta/atualizar`,
    "PUT",
    payload
  );
};

// STATUS OFERTA - INATIVAR
export const inativarStatusOferta = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}StatusOferta/${id}/inativar`,
    "PUT"
  );
};

// STATUS OFERTA - ATIVAR
export const ativarStatusOferta = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}StatusOferta/${id}/ativar`,
    "PUT"
  );
};

// STATUS OFERTA - ATIVAR/INATIVAR (função auxiliar igual de antes, só repassa)
export const toggleStatusOferta = async (id, ativo) => {
  if (ativo) {
    return await ativarStatusOferta(id);
  } else {
    return await inativarStatusOferta(id);
  }
};
